var map = {
	"./SignPainter-HouseScript.svg": 46,
	"./proximasoft-bold-webfont.svg": 47,
	"./proximasoft-regular-webfont.svg": 48
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;


//////////////////
// WEBPACK FOOTER
// ./themes/fq/font ^\.\/.*\.svg$
// module id = 32
// module chunks = d-game